import { render, staticRenderFns } from "./RetailerMargins.vue?vue&type=template&id=d7637500&lang=pug"
import script from "./RetailerMargins.vue?vue&type=script&lang=js"
export * from "./RetailerMargins.vue?vue&type=script&lang=js"
import style0 from "./RetailerMargins.vue?vue&type=style&index=0&id=d7637500&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports